module.exports = __webpack_public_path__ + "img/it_iron_2019_photos_1.092b18d7.jpg";